module.exports = __webpack_public_path__ + "img/tablet-neck-4_18x450.e67484a4.png";